import React, { useContext } from 'react';
import { StyleSheet, View } from 'react-native';
import { rem, SettingsItemNavigate } from 'design-system';
import IconTransfer from 'design-system/icons/IconTransfer';
import { useMainStackNavigation } from 'utils/types/navigationV6';
import TouchableBounceCard from 'utils/packages/TouchableBounceCard';
import { InvestWalkthroughContext } from 'features/feed/components/walkthrough/context';
import { blockInvestOnboardingOnWeb } from '../webGate';
import { isWeb } from '../../../constants';
const strings = {
    title: `Transfer an ISA`,
    description: 'Bring your ISAs together for easier management',
};
const ProductTransferCard = () => {
    const navigation = useMainStackNavigation();
    const isInInvestWalkthrough = useContext(InvestWalkthroughContext);
    return (<TouchableBounceCard style={isInInvestWalkthrough ? styles.walkthroughCard : null} onDark noMarginBottom onPress={() => {
            if (blockInvestOnboardingOnWeb())
                return;
            navigation.navigate('ProductTransferIntro');
        }}>
      <View pointerEvents="none" style={styles.content}>
        <SettingsItemNavigate titleFirst title={strings.title} description={strings.description} icon={<IconTransfer alt gradientKey="skyBlue"/>}/>
      </View>
    </TouchableBounceCard>);
};
const styles = StyleSheet.create({
    // The row has an 8px margin on web; this makes it 16px from both edges of the card
    content: isWeb ? { paddingHorizontal: rem(8) } : {},
    walkthroughCard: {
        marginTop: rem(4),
        marginBottom: rem(4),
        marginHorizontal: 0,
    },
});
export default React.memo(ProductTransferCard);
